(function () {
  if (window.__mSizeChartInit) return;
  window.__mSizeChartInit = true;
  var originals = new WeakMap();
  function getPopup() {
    return document.getElementById('msizeChartPopup');
  }
  function openPopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.add('mpopupActive');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    var popup = getPopup();
    if (popup) popup.classList.remove('mpopupActive');
    document.body.style.overflow = '';
  }
  function textNodes(el) {
    var out = [], w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) out.push(w.currentNode);
    return out;
  }
  function convert(wrap, unit) {
    wrap.querySelectorAll('tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (cell, colIndex) {
        textNodes(cell).forEach(function (node) {
          if (!originals.has(node)) originals.set(node, node.nodeValue);
          var orig = originals.get(node);

          if (colIndex === 0) {
            node.nodeValue = unit === 'in' ? orig.replace(/\(\s*cm\s*\)/i, '(IN)') : orig;
            return;
          }
          node.nodeValue = unit === 'in'
            ? orig.replace(/\d+(\.\d+)?/g, function (n) {
                return (Math.round(parseFloat(n) / 2.54 * 10) / 10).toString();
              })
            : orig;
        });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var popup = getPopup();
    if (e.target.closest('#mpopupToggle')) {
      openPopup();
      return;
    }
    if (
      e.target.closest('#mpopupCloseBtn') ||
      e.target.closest('#mpopupBackBtn') ||
      e.target.closest('[data-msize-back]')
    ) {
      closePopup();
      return;
    }
    if (popup && e.target === popup) {
      closePopup();
      return;
    }
    var unitBtn = e.target.closest('[data-unit-toggle] button[data-unit]');
    if (unitBtn) {
      var root = unitBtn.closest('.msizepopupBox');
      var wrap = root && root.querySelector('.msizeChartInserter');
      if (!wrap) return;
      unitBtn.closest('[data-unit-toggle]').querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === unitBtn);
      });
      convert(wrap, unitBtn.dataset.unit);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });
})();
(function () {
  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
    }

    onSubmit(event) {
      event.preventDefault();
      this.triggerUpdate();
    }

    onChange() {
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => this.triggerUpdate(), 10);
    }

    triggerUpdate() {
      var bar = this.closest('m-filter-bar');
      var params = new URLSearchParams(new FormData(this.form)).toString();
      var base = this.form.getAttribute('action') || window.location.pathname;
      var url = base + (params ? '?' + params : '');

      if (bar && bar.ajaxEnabled) {
        bar.fetchAndRender(url, { pushState: true });
      } else {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('m-facet-filters-form')) {
    customElements.define('m-facet-filters-form', FacetFiltersForm);
  }

  var FB_MOBILE_QUERY = '(max-width: 749px)';

  class FilterBar extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.gridSectionId = (this.dataset.gridSectionId || '').trim();
      this.resultsSelector = (this.dataset.resultsSelector || '').trim();
      this.paginationSelector = (this.dataset.paginationSelector || '').trim();
      this.ajaxEnabled = this.dataset.ajax === 'true';

      this.toggleBtn = this.querySelector('[data-filter-toggle]');
      this.panel = this.querySelector('[data-filter-panel]');
      this.drawer = this.querySelector('[data-filter-drawer]');
      this.clearBtns = this.querySelectorAll('[data-filter-clear]');

      this.syncActiveSurface();

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => {
          if (window.matchMedia(FB_MOBILE_QUERY).matches) {
            this.openDrawer();
          } else {
            this.togglePanel();
          }
        });
      }

      if (this.drawer) {
        this.drawer.querySelectorAll('[data-drawer-open]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.showDrawerScreen(btn.dataset.drawerOpen);
            this.setActiveDrawerNav(btn.dataset.drawerOpen);
          });
        });

        this.drawer.querySelectorAll('[data-drawer-back]').forEach((btn) => {
          btn.addEventListener('click', () => this.showDrawerScreen('root'));
        });

        this.drawer.querySelectorAll('[data-drawer-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.closeDrawer());
        });
      }

      this.clearBtns.forEach((clearBtn) => {
        clearBtn.addEventListener('click', (event) => {
          if (this.ajaxEnabled) {
            event.preventDefault();
            this.fetchAndRender(clearBtn.getAttribute('href'), { pushState: true });
          }
        });
      });

      this._onDocClick = (event) => {
        if (!this.contains(event.target)) this.closePanel();
      };

      this._onDocKeydown = (event) => {
        if (event.key === 'Escape') {
          this.closePanel();
          this.closeDrawer();
        }
      };

      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onDocKeydown);

      this._onResize = () => {
        this.syncActiveSurface();

        if (this.drawer && this.drawer.classList.contains('is-open')) {
          this.positionDrawer();
        }
      };

      window.addEventListener('resize', this._onResize);

      if (this.ajaxEnabled) {
        this._onPopState = () => {
          this.fetchAndRender(window.location.href, { pushState: false });
        };

        window.addEventListener('popstate', this._onPopState);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onDocKeydown);

      if (this._onPopState) {
        window.removeEventListener('popstate', this._onPopState);
      }

      window.removeEventListener('resize', this._onResize);

      if (this.drawer && this.drawer.classList.contains('is-open')) {
        document.body.classList.remove('u-filter-drawer-open');
      }
    }

    syncActiveSurface() {
      var isMobile = window.matchMedia(FB_MOBILE_QUERY).matches;
      var activeRoot = isMobile ? this.drawer : this.panel;
      var inactiveRoot = isMobile ? this.panel : this.drawer;

      if (activeRoot) {
        activeRoot.querySelectorAll('[data-filter-input]').forEach((input) => {
          if (input.dataset.paramName) {
            input.name = input.dataset.paramName;
          }
        });
      }

      if (inactiveRoot) {
        inactiveRoot.querySelectorAll('[data-filter-input]').forEach((input) => {
          input.removeAttribute('name');
        });
      }
    }

    openPanel() {
      if (!this.panel) return;

      this.panel.classList.add('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'true');
    }

    closePanel() {
      if (!this.panel) return;

      this.panel.classList.remove('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'false');
    }

    togglePanel() {
      if (!this.panel) return;

      var isOpen = this.panel.classList.contains('is-open');

      if (isOpen) {
        this.closePanel();
      } else {
        this.openPanel();
      }
    }

    positionDrawer() {
      if (!this.drawer) return;

      var headerEl =
        document.querySelector('sticky-header') ||
        document.querySelector('.header-wrapper');

      if (!headerEl) return;

      var rect = headerEl.getBoundingClientRect();
      this.drawer.style.top = Math.max(rect.bottom, 0) + 'px';
    }

    openDrawer() {
      if (!this.drawer) return;

      this.positionDrawer();
      this.showDrawerScreen('root');
      this.clearActiveDrawerNav();

      this.drawer.classList.add('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'true');

      document.body.classList.add('u-filter-drawer-open');
    }

    closeDrawer() {
      if (!this.drawer) return;

      this.drawer.classList.remove('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'false');

      document.body.classList.remove('u-filter-drawer-open');
    }

    showDrawerScreen(name) {
      if (!this.drawer) return;

      this.drawer.querySelectorAll('[data-drawer-screen]').forEach((el) => {
        el.classList.toggle(
          'is-active',
          el.dataset.drawerScreen === name
        );
      });
    }

    setActiveDrawerNav(name) {
      if (!this.drawer) return;

      this.drawer.querySelectorAll('[data-drawer-open]').forEach((btn) => {
        btn.classList.toggle(
          'is-active',
          btn.dataset.drawerOpen === name
        );
      });
    }

    clearActiveDrawerNav() {
      if (!this.drawer) return;

      this.drawer.querySelectorAll('[data-drawer-open]').forEach((btn) => {
        btn.classList.remove('is-active');
      });
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
    }

    refreshAjaxinate() {
      if (typeof Ajaxinate === 'undefined') return;

      if (
        window.endlessScroll &&
        typeof window.endlessScroll.destroy === 'function'
      ) {
        window.endlessScroll.destroy();
      }

      window.endlessScroll = new Ajaxinate();
    }

    fetchAndRender(url, opts) {
      opts = opts || {};

      var wasOpen = this.panel
        ? this.panel.classList.contains('is-open')
        : false;

      var drawerWasOpen = !!(
        this.drawer &&
        this.drawer.classList.contains('is-open')
      );

      var drawerScreen = 'root';

      if (this.drawer) {
        var activeScreenEl = this.drawer.querySelector(
          '[data-drawer-screen].is-active'
        );

        if (activeScreenEl) {
          drawerScreen = activeScreenEl.dataset.drawerScreen;
        }
      }

      var drawerNav = null;

      if (this.drawer) {
        var activeNavEl = this.drawer.querySelector(
          '[data-drawer-open].is-active'
        );

        if (activeNavEl) {
          drawerNav = activeNavEl.dataset.drawerOpen;
        }
      }

      this.setLoading(true);

      var sectionIds = [this.sectionId];

      if (this.gridSectionId) {
        sectionIds.push(this.gridSectionId);
      }

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      var sectionsUrl =
        url + sep + 'sections=' + sectionIds.join(',');

      var needsFullPageFetch =
        !this.gridSectionId && this.resultsSelector;

      var requests = [
        fetch(sectionsUrl).then((r) => {
          if (!r.ok) throw new Error('bad response');
          return r.json();
        })
      ];

      if (needsFullPageFetch) {
        requests.push(
          fetch(url).then((r) => {
            if (!r.ok) throw new Error('bad response');
            return r.text();
          })
        );
      }

      Promise.all(requests)
        .then((results) => {
          var sectionsData = results[0];
          var fullPageHtml = results[1];

          if (sectionsData[this.sectionId]) {
            this.swapSelf(
              sectionsData[this.sectionId],
              wasOpen,
              drawerWasOpen,
              drawerScreen,
              drawerNav
            );
          }

          if (
            this.gridSectionId &&
            sectionsData[this.gridSectionId]
          ) {
            this.swapById(
              'shopify-section-' + this.gridSectionId,
              sectionsData[this.gridSectionId]
            );
          } else if (
            fullPageHtml &&
            this.resultsSelector
          ) {
            var doc = new DOMParser().parseFromString(
              fullPageHtml,
              'text/html'
            );

            var freshResults = doc.querySelector(
              this.resultsSelector
            );

            var currentResults = document.querySelector(
              this.resultsSelector
            );

            if (freshResults && currentResults) {
              currentResults.replaceWith(
                document.adoptNode(freshResults)
              );
            }

            if (this.paginationSelector) {
              var freshPagination = doc.querySelector(
                this.paginationSelector
              );

              var currentPagination = document.querySelector(
                this.paginationSelector
              );

              if (freshPagination && currentPagination) {
                currentPagination.innerHTML =
                  freshPagination.innerHTML;
              }
            }
          }

          if (opts.pushState) {
            window.history.pushState(
              { filterBarUrl: url },
              '',
              url
            );
          }

          this.refreshAjaxinate();

          window.dispatchEvent(
            new CustomEvent('filter-bar:updated', {
              bubbles: true,
              detail: {
                url: url
              }
            })
          );
        })
        .catch(() => {
          window.location.href = url;
        })
        .finally(() => this.setLoading(false));
    }

    swapSelf(
      html,
      wasOpen,
      drawerWasOpen,
      drawerScreen,
      drawerNav
    ) {
      var temp = document.createElement('div');
      temp.innerHTML = html.trim();

      var fresh =
        temp.querySelector('m-filter-bar') ||
        temp.firstElementChild;

      if (!fresh) return;

      document.adoptNode(fresh);
      this.replaceWith(fresh);

      if (wasOpen) {
        var freshPanel = fresh.querySelector(
          '[data-filter-panel]'
        );

        var freshToggle = fresh.querySelector(
          '[data-filter-toggle]'
        );

        if (freshPanel) {
          freshPanel.classList.add('is-open');
        }

        if (freshToggle) {
          freshToggle.setAttribute(
            'aria-expanded',
            'true'
          );
        }
      }

      if (drawerWasOpen) {
        var freshDrawer = fresh.querySelector(
          '[data-filter-drawer]'
        );

        if (freshDrawer) {
          freshDrawer.classList.add('is-open');

          freshDrawer
            .querySelectorAll('[data-drawer-screen]')
            .forEach((el) => {
              el.classList.toggle(
                'is-active',
                el.dataset.drawerScreen === drawerScreen
              );
            });

          if (drawerNav) {
            freshDrawer
              .querySelectorAll('[data-drawer-open]')
              .forEach((btn) => {
                btn.classList.toggle(
                  'is-active',
                  btn.dataset.drawerOpen === drawerNav
                );
              });
          }
        }

        if (typeof fresh.positionDrawer === 'function') {
          fresh.positionDrawer();
        }

        document.body.classList.add(
          'u-filter-drawer-open'
        );
      }
    }

    swapById(id, html) {
      var current = document.getElementById(id);

      if (!current) return;

      var temp = document.createElement('div');
      temp.innerHTML = html.trim();

      var fresh =
        temp.querySelector('#' + id) ||
        temp.firstElementChild;

      if (!fresh) return;

      document.adoptNode(fresh);
      current.replaceWith(fresh);
    }
  }

  if (!customElements.get('m-filter-bar')) {
    customElements.define('m-filter-bar', FilterBar);
  }
})();

/* =========================================================
   M-HEADER 
 ========================================================= */

(function () {
  function initMHeaderMobileMenu() {

    const drawer = document.querySelector(
      '.m-header .menu-drawer'
    );

    if (!drawer) return;

    /* Prevent duplicate initialization */
    if (drawer.dataset.mMenuInitialized === 'true') return;

    drawer.dataset.mMenuInitialized = 'true';


    const triggers = drawer.querySelectorAll(
      '.m-menu-trigger'
    );

    const backButtons = drawer.querySelectorAll(
      '.m-menu-back'
    );

    const panels = drawer.querySelectorAll(
      '.m-menu-panel'
    );


    /* =====================================================
       HELPER
       ===================================================== */

    function getPanel(id) {
      return drawer.querySelector(
        '#' + CSS.escape(id)
      );
    }


    /* =====================================================
       REMOVE ACTIVE STATES
       ===================================================== */

    function clearSelected() {

      drawer
        .querySelectorAll(
          '.m-menu-trigger.is-selected'
        )
        .forEach(function (item) {

          item.classList.remove(
            'is-selected'
          );

          item.setAttribute(
            'aria-expanded',
            'false'
          );

        });
    }


    /* =====================================================
       RESET TO MAIN MENU
       ===================================================== */

    function resetMenu() {

      drawer.classList.remove(
        'm-menu-level-1',
        'm-menu-level-2'
      );


      panels.forEach(function (panel) {

        panel.classList.remove(
          'is-active'
        );

      });


      clearSelected();


      const mainPanel = drawer.querySelector(
        '.m-menu-panel--main'
      );

      if (mainPanel) {

        mainPanel.classList.add(
          'is-active'
        );

      }

    }


    /* =====================================================
       LEVEL 1
       MAIN → CHILD
       ===================================================== */

    function openChildPanel(
      targetId,
      trigger
    ) {

      const target = getPanel(
        targetId
      );

      if (!target) return;


      /*
       * VERY IMPORTANT:
       * Do not allow Dawn to interpret this click
       * as drawer navigation.
       */

      if (trigger) {

        trigger.classList.add(
          'is-selected'
        );

        trigger.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      /*
       * Remove previous selected items
       * from the same menu only.
       */

      if (trigger) {

        const parentList =
          trigger.closest(
            '.menu-drawer__menu'
          );

        if (parentList) {

          parentList
            .querySelectorAll(
              ':scope > li > .m-menu-trigger.is-selected'
            )
            .forEach(function (item) {

              if (item !== trigger) {

                item.classList.remove(
                  'is-selected'
                );

                item.setAttribute(
                  'aria-expanded',
                  'false'
                );

              }

            });

        }

      }


      /*
       * Hide currently open child/grandchild panels.
       */

      panels.forEach(function (panel) {

        if (
          panel.classList.contains(
            'm-menu-panel--child'
          )
        ) {

          panel.classList.remove(
            'is-active'
          );

        }

        if (
          panel.classList.contains(
            'm-menu-panel--grand'
          )
        ) {

          panel.classList.remove(
            'is-active'
          );

        }

      });


      /*
       * Open child state.
       */

      drawer.classList.remove(
        'm-menu-level-2'
      );

      drawer.classList.add(
        'm-menu-level-1'
      );


      target.classList.add(
        'is-active'
      );

    }


    /* =====================================================
       LEVEL 2
       CHILD → GRANDCHILD
       ===================================================== */

    function openGrandPanel(
      targetId,
      trigger
    ) {

      const target = getPanel(
        targetId
      );

      if (!target) return;


      const parentId =
        target.getAttribute(
          'data-panel-parent'
        );


      const parentPanel =
        getPanel(parentId);


      if (!parentPanel) return;


      /*
       * Selected item indicator.
       */

      const parentList =
        trigger.closest(
          '.menu-drawer__menu'
        );

      if (parentList) {

        parentList
          .querySelectorAll(
            ':scope > li > .m-menu-trigger.is-selected'
          )
          .forEach(function (item) {

            item.classList.remove(
              'is-selected'
            );

            item.setAttribute(
              'aria-expanded',
              'false'
            );

          });

      }


      trigger.classList.add(
        'is-selected'
      );

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );


      /*
       * Remove existing panels.
       */

      panels.forEach(function (panel) {

        panel.classList.remove(
          'is-active'
        );

      });


      /*
       * LEVEL 2:
       *
       * LEFT  = child panel
       * RIGHT = grandchild panel
       */

      drawer.classList.remove(
        'm-menu-level-1'
      );

      drawer.classList.add(
        'm-menu-level-2'
      );


      parentPanel.classList.add(
        'is-active'
      );


      target.classList.add(
        'is-active'
      );

    }


    /* =====================================================
       TRIGGER CLICK
       ===================================================== */

    triggers.forEach(function (trigger) {

      trigger.addEventListener(
        'click',
        function (event) {

          /*
           * CRITICAL:
           * Stop the click from reaching Dawn's
           * menu-drawer click handling.
           */

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();


          const targetId =
            trigger.getAttribute(
              'data-menu-target'
            );

          if (!targetId) return;


          const target =
            getPanel(targetId);

          if (!target) return;


          const panelType =
            target.getAttribute(
              'data-menu-panel'
            );


          if (
            panelType === 'child'
          ) {

            openChildPanel(
              targetId,
              trigger
            );

          }


          if (
            panelType === 'grand'
          ) {

            openGrandPanel(
              targetId,
              trigger
            );

          }

        },
        true
      );

    });


    /* =====================================================
       BACK BUTTON
       ===================================================== */

    backButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();


          const targetId =
            button.getAttribute(
              'data-menu-back'
            );


          /*
           * Back to MAIN
           */

          if (
            targetId === 'main'
          ) {

            resetMenu();

            return;

          }


          /*
           * Back to CHILD
           */

          const targetPanel =
            getPanel(targetId);


          if (!targetPanel) return;


          panels.forEach(function (panel) {

            panel.classList.remove(
              'is-active'
            );

          });


          drawer.classList.remove(
            'm-menu-level-2'
          );

          drawer.classList.add(
            'm-menu-level-1'
          );


          targetPanel.classList.add(
            'is-active'
          );


          /*
           * Remove grandchild selected state.
           */

          targetPanel
            .querySelectorAll(
              '.m-menu-trigger.is-selected'
            )
            .forEach(function (item) {

              item.classList.remove(
                'is-selected'
              );

              item.setAttribute(
                'aria-expanded',
                'false'
              );

            });

        },
        true
      );

    });


    /* =====================================================
       DO NOT RESET WHEN DRAWER IS OPENED
       ===================================================== */

    const menuDetails =
      drawer.closest('details');


    /*
     * Only reset when the actual drawer is CLOSED.
     */

    if (menuDetails) {

      menuDetails.addEventListener(
        'toggle',
        function () {

          if (!menuDetails.open) {

            resetMenu();

          }

        }
      );

    }


    /* =====================================================
       INITIAL STATE
       ===================================================== */

    resetMenu();

  }


  /* =========================================================
     INIT
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMHeaderMobileMenu
    );

  } else {

    initMHeaderMobileMenu();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.target &&
        event.target.querySelector(
          '.m-header .menu-drawer'
        )
      ) {

        initMHeaderMobileMenu();

      }

    }
  );

})();

// Header JS END

function initSlideshowTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initCartTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initMarqueeTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initProductTimer(targetDate, targetClass) {
    startNewTimer(targetDate,targetClass);
  }
  
function startNewTimer(targetDate,targetClass) {
  const targetTime = new Date(targetDate).getTime();
  const timers = document.querySelectorAll(targetClass);

  function updateNewTimer() {
    const currentTime = new Date().getTime();
    const timeDifference = targetTime - currentTime;

    let days = 0, hours = 0, minutes = 0, seconds = 0;

    if (timeDifference > 0) {
      days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    }

    timers.forEach(timer => {
      const daysEl = timer.querySelector('.timer-mdays');
      const hoursEl = timer.querySelector('.timer-mhours');
      const minutesEl = timer.querySelector('.timer-mminutes');
      const secondsEl = timer.querySelector('.timer-mseconds');

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    });
  }

  updateNewTimer();
  const mtimerInterval = setInterval(updateNewTimer, 1000);

  document.addEventListener('shopify:section:unload', () => clearInterval(mtimerInterval));
}

  
function initAnnouncementTimer(targetDate) {
    startTimer(targetDate);
  }
  
  function startTimer(targetDate) {
    const daysElement = document.getElementById('days');
    const hoursElement = document.getElementById('hours');
    const minutesElement = document.getElementById('minutes');
    const secondsElement = document.getElementById('seconds');
  
    const targetTime = new Date(targetDate).getTime();
  
    if (daysElement && hoursElement && minutesElement && secondsElement) {
      function updateTimer() {
        const currentTime = new Date().getTime();
        const timeDifference = targetTime - currentTime;
  
        if (timeDifference <= 0) {
          daysElement.textContent = "00";
          hoursElement.textContent = "00";
          minutesElement.textContent = "00";
          secondsElement.textContent = "00";
          return;
        }
  
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
  
        daysElement.textContent = String(days).padStart(2, '0');
        hoursElement.textContent = String(hours).padStart(2, '0');
        minutesElement.textContent = String(minutes).padStart(2, '0');
        secondsElement.textContent = String(seconds).padStart(2, '0');
      }
  
      updateTimer();
      const timerInterval = setInterval(updateTimer, 1000);
  
      document.addEventListener('shopify:section:unload', () => clearInterval(timerInterval));
    }
  }
  
function initmslideshowswiper(autoPlay, time) {
  var swiper = new Swiper(".mslideshowswiper", {
    loop: true,
    autoplay: autoPlay ? {
      delay: parseInt(time) || 7000,  // Fallback to 7000 if time is invalid
      disableOnInteraction: true,
    } : false, // Disable autoplay if autoPlay is false
    speed: 1000,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}



function toggleChat() {
    const chatHost = document.querySelector('#shopify-chat inbox-online-store-chat');
    
    if (chatHost && chatHost.shadowRoot) {
        const button = chatHost.shadowRoot.querySelector('button'); // Change this to the specific button selector if needed
        if (button) {
            button.click(); // Simulate button click
        } 
    }
}


document.addEventListener('DOMContentLoaded', () => {
        const updateFilterPosition = () => {
            const header = document.querySelector('.section-header');
            const filters = document.querySelector('#main-collection-filters');
          if (header && filters){
            const headerHeight = header.offsetHeight - 2;
            filters.style.top = `${headerHeight}px`;
          }
        };

        // Update on scroll
        window.addEventListener('scroll', updateFilterPosition);

        // Initial update in case scroll doesn't occur
        updateFilterPosition();
   
});

 document.addEventListener("DOMContentLoaded", function() {
      let headings = document.getElementsByClassName("mcollapse-heading");
      for (let i = 0; i < headings.length; i++) {
          headings[i].addEventListener("click", function() {
              this.classList.toggle("active");
              let content = this.nextElementSibling;
              if (content && content.classList.contains("mcollapse-content")) {
                  if (content.style.maxHeight) {
                      content.style.maxHeight = null;
                  } else {
                      content.style.maxHeight = content.scrollHeight + "px";
                  }
              }
          });
      }
  });

// Handle #magree checkbox
var magreeCheckbox = document.getElementById('magree');
if (magreeCheckbox) {
    magreeCheckbox.addEventListener('change', function() {
        var cartDrawerCheckout = document.querySelector('.mcart-drawer-checkout');
        if (cartDrawerCheckout) {
            if (this.checked) {
                cartDrawerCheckout.classList.remove('mnotchecked');
            } else {
                cartDrawerCheckout.classList.add('mnotchecked');
            }
        }
    });
}

// Handle #agree checkbox
var agreeCheckbox = document.getElementById('agree');
if (agreeCheckbox) {
    agreeCheckbox.addEventListener('change', function() {
        var checkoutButton = document.getElementById('checkout');
        if (checkoutButton) {
            checkoutButton.disabled = !this.checked;
        }
    });
}

function initAnnouncementStickiness() {
  let lastScrollY = window.scrollY;

  function isElementMovedUpAndOutOfViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom <= 0 && rect.top < window.innerHeight;
  }

  function checkVisibility() {
    const ogPaymentElement = document.querySelector(".M-sticky-announcement-target");
    const stickyatc = document.querySelector(".msticky-announcement");

    if (!ogPaymentElement || !stickyatc) return;

    const currentScrollY = window.scrollY;

    const scrollingDown = currentScrollY > lastScrollY;

    if (scrollingDown && isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mannouncement-sticky");
    } else if (!scrollingDown) {
      stickyatc.classList.remove("mannouncement-sticky");
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);
  checkVisibility();
}

function checkAndPlayVideo() {
    var videos = document.querySelectorAll(".mproduct-video");
    
    // Only proceed if there's at least one video
    if (videos.length === 0) return;

    videos.forEach(function(video) {
        if (video.paused) {
            video.play();
            console.log("Video was paused. Resuming playback.");
        }
    });
}

setInterval(checkAndPlayVideo, 1000);

document.addEventListener('DOMContentLoaded', () => {
  // Only run this on mobile (optional)
  if (window.innerWidth <= 768) { // Adjust breakpoint as needed
    document.querySelectorAll('[id^="Details-"].mcollapse').forEach((detailsEl) => {
      detailsEl.removeAttribute('open');
    });

    document.querySelectorAll('[id^="Details-"].mcollapse summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
    });
  }
});
